import {Component, OnDestroy, OnInit} from '@angular/core';
import { SectionBase } from '../../../components/section/section-base';
import { UrlParamsService } from '../../../../core/services/impl/url-params.service';
import { FormFactoryService } from '../../../services/form-factory.service';
import { AdditionalDataSectionConfig } from './additional-data-section.config';
import { AdditionalDataSectionConsts } from './additional-data-section.consts';
import { CalculationService } from '../../../../core/services/impl/calculation.service';
import { VehicleModelStateService } from '../../../../core/services/impl/section-services/vehicle-model/vehicle-model-state.service';
import { AdditionalDataService } from '../../../../core/services/impl/section-services/additional-data/additional-data.service';
import {Subscription} from 'rxjs/Rx';
import {RegExpService} from '../../../services/reg-exp.service';

@Component({
  selector: 'app-additional-data-section',
  templateUrl: './additional-data-section.component.html'
})
export class AdditionalDataSectionComponent extends SectionBase implements OnInit, OnDestroy {

  public additionalDataConfig: AdditionalDataSectionConfig;
  public consts = AdditionalDataSectionConsts;
  private subscriptions: Subscription[] = [];

  get sectionVisible(): boolean {
    return this.urlParamsService.isLoggedUserIdParam;
  }

  constructor(private urlParamsService: UrlParamsService,
              private calculationService: CalculationService,
              private vehicleModelStateService: VehicleModelStateService,
              private additionalDataService: AdditionalDataService,
              private regExpService: RegExpService) {
    super();
  }

  ngOnInit() {
    this.createConfig();
    this.initBean();
    this.buildForm();
    this.initControlsChanges();
    this.handleEvents();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
    this.subscriptions = [];
  }

  createConfig(): void {
    this.additionalDataConfig = new AdditionalDataSectionConfig(this.regExpService);
    this.formConfig = this.additionalDataConfig.createConfig();
  }

  buildForm(): void {
    this.formFactoryService = new FormFactoryService(this.formConfig, this.bean);
    this.formFactoryService.buildFormGroup(this.formGroup);
  }

  initBean(): void {
    this.bean = this.calculationService.vehicleData;
  }

  initControlsChanges(): void {
    this.vehicleModelStateService.vinChangeEvent.subscribe(vin => {
      this.formGroup.get(this.consts.VIN).patchValue(vin);
      this.additionalDataService.changeVinNumber(vin);
    });

    this.formGroup.get(this.consts.VIN).valueChanges.subscribe(vin => {
      this.additionalDataService.changeVinNumber(vin);
    });
  }

  isSectionValid(): boolean {
    return this.sectionVisible ? super.isSectionValid() : true;
  }

  private handleEvents() {
    if (this.sectionVisible) {
      this.subscriptions.push(
          this.vehicleModelStateService.clearVehicleDataEvent.subscribe(() => this.getControl(AdditionalDataSectionConsts.VIN).reset())
      );
    }
  }
}
